export default __webpack_public_path__ + "static/media/darrell issa.efd0e35e.jpg";